import request from '@/utils/request'

export const getHouseholdByPhone = (data = {}) => request({ url: `/api/estate/v1/household/getHouseholdByPhone`, method: 'post', data })

// 楼栋管理
export const buildingPage = (data = {}) => request({ url: `/api/estate/v1/asset/buildingPage`, method: 'post', data })

export const buildingCount = (data = {}) => request({ url: `/api/estate/v1/asset/buildingCount`, method: 'post', data })

export const buildingDetail = (data = {}) => request({ url: `/api/estate/v1/asset/buildingDetail`, method: 'post', data })

export const buildingIns = (data = {}) => request({ url: `/api/estate/v1/asset/buildingIns`, method: 'post', data })

export const buildingCustomIns = (data = {}) => request({ url: `/api/estate/v1/asset/buildingCustomIns    `, method: 'post', data })

export const buildingUpd = (data = {}) => request({ url: `/api/estate/v1/asset/buildingUpd`, method: 'post', data })

export const buildingDel = (data = {}) => request({ url: `/api/estate/v1/asset/buildingDel`, method: 'post', data })

export const buildingDelBatch = (data = {}) => request({ url: `/api/estate/v1/asset/buildingDelBatch`, method: 'post', data })

export const emptyBuildingRoomByBuildingId = (data = {}) => request({ url: `/api/estate/v1/asset/emptyBuildingRoomByBuildingId`, method: 'post', data })

export const buildManagerPage = (data = {}) => request({ url: `/api/estate/v1/asset/buildManagerPage`, method: 'post', data })

export const unitManagerPage = (data = {}) => request({ url: `/api/estate/v1/asset/unitManagerPage`, method: 'post', data })

export const buildManagerUpd = (data = {}) => request({ url: `/api/estate/v1/asset/buildManagerUpd`, method: 'post', data })

export const buildingUnitManagerUpd = (data = {}) => request({ url: `/api/estate/v1/asset/buildingUnitManagerUpd`, method: 'post', data })

// 单元管理
export const buildingUnitPage = (data = {}) => request({ url: `/api/estate/v1/asset/buildingUnitPage`, method: 'post', data })

export const buildingUnitCount = (data = {}) => request({ url: `/api/estate/v1/asset/buildingUnitCount`, method: 'post', data })

export const buildingUnitDetail = (data = {}) => request({ url: `/api/estate/v1/asset/buildingUnitDetail`, method: 'post', data })

export const buildingUnitIns = (data = {}) => request({ url: `/api/estate/v1/asset/buildingUnitIns`, method: 'post', data })

export const buildingUnitUpd = (data = {}) => request({ url: `/api/estate/v1/asset/buildingUnitUpd`, method: 'post', data })

export const buildingUnitDel = (data = {}) => request({ url: `/api/estate/v1/asset/buildingUnitDel`, method: 'post', data })

export const buildingUnitDelBatch = (data = {}) => request({ url: `/api/estate/v1/asset/buildingUnitDelBatch`, method: 'post', data })

// 楼层管理
export const buildingFloorPage = (data = {}) => request({ url: `/api/estate/v1/asset/buildingFloorPage`, method: 'post', data })

export const buildingFloorCount = (data = {}) => request({ url: `/api/estate/v1/asset/buildingFloorCount`, method: 'post', data })

export const buildingFloorDetail = (data = {}) => request({ url: `/api/estate/v1/asset/buildingFloorDetail`, method: 'post', data })

export const buildingFloorIns = (data = {}) => request({ url: `/api/estate/v1/asset/buildingFloorIns`, method: 'post', data })

export const buildingFloorUpd = (data = {}) => request({ url: `/api/estate/v1/asset/buildingFloorUpd`, method: 'post', data })

export const buildingFloorDel = (data = {}) => request({ url: `/api/estate/v1/asset/buildingFloorDel`, method: 'post', data })

export const buildingFloorDelBatch = (data = {}) => request({ url: `/api/estate/v1/asset/buildingFloorDelBatch`, method: 'post', data })

// 房屋管理
export const buildingRoomPage = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomPage`, method: 'post', data })

export const buildingRoomCount = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomCount`, method: 'post', data })

export const buildingRoomDetail = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomDetail`, method: 'post', data })

export const buildingRoomIns = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomIns`, method: 'post', data })

export const buildingRoomUpd = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomUpd`, method: 'post', data })

export const buildingRoomDel = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomDel`, method: 'post', data })

export const buildingRoomDelBatch = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomDelBatch`, method: 'post', data })

export const mergeBuildingRooms = (data = {}) => request({ url: `/api/estate/v1/asset/mergeBuildingRooms`, method: 'post', data })

export const splitBuildingRooms = (data = {}) => request({ url: `/api/estate/v1/asset/splitBuildingRooms`, method: 'post', data })

export const roomRecordList = (data = {}) => request({ url: `/api/estate/v1/asset/roomRecordList`, method: 'post', data })

export const buildingRoomChangePage = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomChangePage`, method: 'post', data })

export const buildingRoomChangeCount = (data = {}) => request({ url: `/api/estate/v1/asset/buildingRoomChangeCount`, method: 'post', data })

export const shelvesBuildingRooms = (data = {}) => request({ url: `/api/estate/v1/asset/shelvesBuildingRooms`, method: 'post', data })

// 住户管理
export const householdPage = (data = {}) => request({ url: `/core/householdPage`, method: 'post', data })

export const householdIns = (data = {}) => request({ url: `/core/householdIns`, method: 'post', data })

export const householdUpd = (data = {}) => request({ url: `/core/householdUpd`, method: 'post', data })

export const householdDel = (data = {}) => request({ url: `/core/householdDel`, method: 'post', data })

export const householdManagementInfoPage = (data = {}) => request({ url: `/api/estate/v1/household/householdManagementInfoPage`, method: 'post', data })

export const householdManagementInfoCount = (data = {}) => request({ url: `/api/estate/v1/household/householdManagementInfoCount`, method: 'post', data })

export const householdUntieRoom = (data = {}) => request({ url: `/api/estate/v1/household/householdUntieRoom`, method: 'post', data })

export const householdBindRoom = (data = {}) => request({ url: `/api/estate/v1/household/householdBindRoom`, method: 'post', data })

export const householdEmptyPhonePage = (data = {}) => request({ url: `/api/estate/v1/household/householdEmptyPhonePage`, method: 'post', data })

export const householdEmptyPhoneCountPage = (data = {}) => request({ url: `/api/estate/v1/household/householdEmptyPhoneCountPage`, method: 'post', data })

export const householdUnJoinCommunityPage = (data = {}) => request({ url: `/api/estate/v1/household/householdUnJoinCommunityPage`, method: 'post', data })

export const householdStatic = (data = {}) => request({ url: `/api/estate/v1/household/householdStatic`, method: 'post', data })

export const householdUnbindWeixin = (data = {}) => request({ url: `/api/estate/v1/household/householdUnbindWeixin`, method: 'post', data })

//住户列表
export const householdRoomAsset = (data = {}) => request({ url: `/api/estate/v1/household/householdRoomAsset`, method: 'post', data })

export const householdRoomAssetCount = (data = {}) => request({ url: `/api/estate/v1/household/householdRoomAssetCount`, method: 'post', data })

export const holdParkingInfo = (data = {}) => request({ url: `/api/estate/v1/household/holdParkingInfo`, method: 'post', data })

export const holdCarInfo = (data = {}) => request({ url: `/api/estate/v1/household/holdCarInfo`, method: 'post', data })

export const householdBaseInfoDetail = (data = {}) => request({ url: `/api/estate/v1/household/householdBaseInfoDetail`, method: 'post', data })

export const householdBaseInfoPage = (data = {}) => request({ url: `/api/estate/v1/household/householdBaseInfoPage`, method: 'post', data })

export const householdBaseInfoCount = (data = {}) => request({ url: `/api/estate/v1/household/householdBaseInfoCount`, method: 'post', data })

export const householdIndividualInfoIns = (data = {}) => request({ url: `/api/estate/v1/household/householdIndividualInfoIns`, method: 'post', data })

export const companyInfoIns = (data = {}) => request({ url: `/api/estate/v1/household/companyInfoIns`, method: 'post', data })

export const householdInfoUpd = (data = {}) => request({ url: `/api/estate/v1/household/householdInfoUpd`, method: 'post', data })

export const householdBaseInfoDel = (data = {}) => request({ url: `/api/estate/v1/household/householdBaseInfoDel`, method: 'post', data })

export const householdBaseInfoDelBatch = (data = {}) => request({ url: `/api/estate/v1/household/householdBaseInfoDelBatch`, method: 'post', data })

//业务办理-查住户-住户管理
export const buildRoomManagementInfoPage = (data = {}) => request({ url: `/api/estate/v1/household/buildRoomManagementInfoPage`, method: 'post', data })

export const buildRoomManagementInfoCount = (data = {}) => request({ url: `/api/estate/v1/household/buildRoomManagementInfoCount`, method: 'post', data })

export const contractDeductionUnbind = (data = {}) => request({ url: `/api/estate/v1/finance/contractDeductionUnbind`, method: 'post', data })

export const contractDeductionUpd = (data = {}) => request({ url: `/api/estate/v1/finance/contractDeductionUpd`, method: 'post', data })

export const contractDeductionIns = (data = {}) => request({ url: `/api/estate/v1/finance/contractDeductionIns`, method: 'post', data })

export const contractDeductionPage = (data = {}) => request({ url: `/api/estate/v1/finance/contractDeductionPage`, method: 'post', data })

export const contractDeductionCount = (data = {}) => request({ url: `/api/estate/v1/finance/contractDeductionCount`, method: 'post', data })

// 获取房屋总数
export const getRoomCount = (data = {}) => request({ url: `/api/estate/v1/asset/getRoomCount`, method: 'post', data })

// 代扣管理
export const contractDeductionOrder = (data = {}) => request({ url: `/api/estate/v1/finance/contractDeductionOrder`, method: 'post', data })

export const contractDeductionOrderDetailPage = (data = {}) => request({ url: `/api/estate/v1/finance/contractDeductionOrderDetailPage`, method: 'post', data })

export const contractDeductionOrderDetailCount = (data = {}) => request({ url: `/api/estate/v1/finance/contractDeductionOrderDetailCount`, method: 'post', data })
